import { SearchQuery } from "../../code/search-query/search-query";
import ManagedGridView from "../../controls/ManagedGridView";
import { getWellbeingReports } from "../../repository/data.repository";
import { createGridRequest } from "../../hooks/useGridRequest";
import {
  reportsViewColumns,
  mapReportsViewQuery,
  reportsSearchSchema,
} from "./ReportsView.default";
import { useSelector } from "../../store/store";
import { authorizeSelectors } from "../../store/authorize";

export interface ReportsViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function ReportsView(props: ReportsViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={reportsViewColumns}
      schema={reportsSearchSchema}
      mapQuery={mapReportsViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getWellbeingReports, { retry: true })}
      pageSize={100}
      actions={[
        {
          key: "manage",
          label: "Manage",
          disabled: !permissions.can("WellbeingReports", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("WellbeingReports", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default ReportsView;
